import { render } from "./MusicDetail.vue?vue&type=template&id=12f03700"
import script from "./MusicDetail.vue?vue&type=script&lang=js"
export * from "./MusicDetail.vue?vue&type=script&lang=js"

import "./MusicDetail.vue?vue&type=style&index=0&id=12f03700&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__